/* eslint-disable @typescript-eslint/naming-convention */
import { Pagination, Swiper, Autoplay } from 'swiper';

class OfferSwiperSection {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.swiperEl = this.element.querySelector('.offer-swiper, .special-swiper');
    this.swiper = null;
    this.countEl = this.element.querySelector('.swiper-counter');
    this.paginationEl = this.swiperEl.querySelector('.swiper-pagination');

    this.observer = new IntersectionObserver(this.intersectionCallback.bind(this), {
      rootMargin: '0px',
      threshold: 1.0,
    });

    this.initSwiper();
    this.observer.observe(this.element);
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 8000,
      },
      pagination: {
        el: this.paginationEl,
        type: 'bullets',
      },
      loop: false,
      breakpoints: {
        480: {
          slidesPerView: 'auto',
        },
      },
      on: {
        init: (swiper) => {
          swiper.autoplay.stop();
          this.updateCount(swiper);
        },
        slideChange: this.updateCount.bind(this),
        touchStart: this.disableAutoplay.bind(this),
      },
    });
  }

  updateCount(swiper) {
    if (this.countEl) {
      this.countEl.innerText = `${(swiper.activeIndex + 1)} of ${swiper.slides.length}`;
    }
  }

  disableAutoplay() {
    this.swiper.autoplay.stop();
  }

  intersectionCallback(entries) {
    if (!this.swiper) return false;

    const visibleElements = Array.from(entries).filter((entry) => entry.isIntersecting);

    if (visibleElements.length) {
      this.swiper.autoplay.start();
    } else {
      this.swiper.autoplay.stop();
    }

    return true;
  }
}

export default OfferSwiperSection;
